import { render, staticRenderFns } from "./ReportConfigDialog.vue?vue&type=template&id=b5fda6a8&scoped=true&"
import script from "./ReportConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ReportConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fda6a8",
  null
  
)

export default component.exports